import React from 'react';
import UserStatsChart from '../../components/admin/userManagement/UserStatsChart';
import UserList from '../../components/admin/userManagement/UserList';
import CreateAdminForm from '../../components/admin/userManagement/CreateAdminForm';
import UserActionsForm from '../../components/admin/userManagement/UserActionsForm';

const UserManagementPage: React.FC = () => {
  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
        <h1 className="h2">Kullanıcı Yönetimi</h1>
      </div>
      <div className="row mb-4 g-4">
        <div className="col-lg-6">
          <div className="card h-100">
            <div className="card-header">
              <h6 className="mb-0">Kullanıcı İstatistikleri</h6>
            </div>
            <div className="card-body overflow-x-auto">
              <UserStatsChart />
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <UserList />
        </div>
      </div>
      <div className="row mb-4 g-4">
        <div className="col-lg-6">
          <CreateAdminForm />
        </div>
        <div className="col-lg-6">
          <UserActionsForm />
        </div>
      </div>
    </>
  );
};

export default UserManagementPage;
